<template lang="pug">
section(:class="{'u-mt-md': !article.styles || !article.styles.length || (article.styles.length === 1 && article.styles[0].class === 'is-dark' ) }")
  Content
    div(v-html="article.body")

  div.u-mh-md(ref="comments")
    .grid.is-desktop-8.is-tablet-9.is-center
      .column
        h2.u-mb-sm {{$t('comments')}}
        Query.grid.is-12(
          ref="query"
          :query="require('~/graphql/Article.gql').Comments"
          :variables="({ first, after }) => ({ first, after, slug: article.slug })"
          v-slot="{ items }"
        )
          .column(v-for="comment in items" :key="comment.id")
            Comment.u-mb-sm(
              :firstName="comment.author.firstName"
              :lastName="comment.author.lastName"
              :body="comment.body"
            )


        ValidationObserver(ref="form")
          form.form(slot-scope="{ validate }" @submit.prevent="validate().then(addComment)" novalidate)

            template(v-if="!isLoggedIn")
                TextInput(
                  :name="$t('forms.fname')"
                  :label="$t('forms.fname')"
                  rules="required"
                  v-model="firstName"
                )

                TextInput(
                  :name="$t('forms.lname')"
                  :label="$t('forms.lname')"
                  rules="required"
                  v-model="lastName"
                )

                TextInput(
                  :name="$t('forms.email')"
                  :label="$t('forms.email')"
                  rules="required|email"
                  type="email"
                  v-model="email"
                )

            TextInput(
              name="body"
              label="Your Message"
              type="textarea"
              :label="$t('forms.message')"
              rules="required"
              v-model="body"
            )

            button.button-link.is-large(v-load="isSubmitting") {{ $t('forms.send') }}

</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate/dist/vee-validate.minimal';
import TextInput from '~/components/inputs/TextInput';
import Content from '~/components/Content';
import Comment from '~/components/Comment';
import { CreateComment } from '~/graphql/Comment.gql';
import { load } from '~/directives';

export default {
  name: 'ArticleView',
  components: {
    Content,
    Comment,
    ValidationObserver,
    TextInput,
    Query: () => import('../Query.vue')
  },
  directives: {
    load
  },
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    body: '',
    firstName: '',
    lastName: '',
    email: '',
    isSubmitting: false
  }),
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    })
  },
  methods: {
    async addComment() {
      try {
        this.isSubmitting = true;
        const { data } = await this.$api.mutate({
          mutation: CreateComment,
          variables: {
            input: {
              entityId: this.article.id,
              entityType: 'Article',
              body: this.body,
              firstName: this.isLoggedIn ? undefined : this.firstName,
              lastName: this.isLoggedIn ? undefined : this.lastName,
              email: this.isLoggedIn ? undefined : this.email
            }
          }
        });

        this.$refs.query.setItems({
          items: [data.createComment],
          pageInfo: {
            hasNext: this.$refs.query.hasNext
          }
        });
        this.body = '';
        requestAnimationFrame(() => {
          this.$refs.form.reset();
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "commentsFailed": "Failed to load comments",
    "comments":"Comments"
  },
  "ar": {
    "commentsFailed": "خطأ اثناء تحميل التعليقات",
    "comments":"التعليقات"
  }
}
</i18n>
